module.exports = __webpack_public_path__ + "static/slack-b4cc65d95e4ffcc4c505b83de2d718b1.jpg";